(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-recommendations"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__resourceListCartAjaxInit) return;
    window.__resourceListCartAjaxInit = true;

    function openCartDrawer(cart) {
      var drawer =
        document.querySelector('cart-drawer-component') ||
        document.querySelector('cart-drawer') ||
        document.querySelector('[data-cart-drawer]') ||
        document.querySelector('#cart-drawer');

      if (drawer) {
        try {
          if (typeof drawer.open === 'function') {
            drawer.open();
            return true;
          }
          if ('open' in drawer) {
            drawer.open = true;
            return true;
          }
          if (typeof drawer.show === 'function') {
            drawer.show();
            return true;
          }
        } catch (e) {
          /* fall through to attribute/class fallback */
        }
        drawer.setAttribute('open', '');
        drawer.classList.add('active', 'is-open', 'drawer--open');
        return true;
      }

      // Fallback: click the existing header cart icon/link, which already
      // knows how to open this theme's drawer without a full navigation.
      var cartLink = document.querySelector(
        'a[href$="/cart"], [data-cart-icon], [data-cart-drawer-toggle], .header__icon--cart'
      );
      if (cartLink) {
        cartLink.click();
        return true;
      }

      return false;
    }

    function notifyThemeCartUpdated(cart) {
      ['cart:update', 'cart:refresh', 'cart:build', 'cart:change'].forEach(function (name) {
        document.dispatchEvent(
          new CustomEvent(name, {
            bubbles: true,
            detail: { data: { itemCount: cart.item_count, source: 'resource-list' }, cart: cart },
          })
        );
      });

      document
        .querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble')
        .forEach(function (el) {
          el.textContent = cart.item_count;
        });
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest && event.target.closest('.resource-list__row-form');
      if (!form) return;

      // Always stop the native submit so it can never navigate to /cart.
      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('button[type="submit"]');
      var originalDisabled = button ? button.disabled : false;
      if (button) button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart request failed');
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (res) {
            return res.json();
          });
        })
        .then(function (cart) {
          notifyThemeCartUpdated(cart);
          openCartDrawer(cart);
        })
        .catch(function (error) {
          console.error('Resource list add to cart failed:', error);
        })
        .finally(function () {
          if (button) button.disabled = originalDisabled;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
